import { addParts, allParts, deleteParts, updateParts } from '@/utils/request'
import vue from '@/main'

const state = {
  partsList: []
}

const mutations = {
  RESET (state) {
    state.partsList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allParts().then(response => {
        state.partsList = response.data
        resolve(state.partsList)
      })
    })
  },
  partsById ({ commit, state }, id) {
    for (const team of state.partsList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, parts) {
    return new Promise((resolve) => {
      updateParts(parts).then(() => {
        for (const cur of state.partsList) {
          if (cur.id === parts.id) {
            Object.assign(cur, parts)
            break
          }
        }
        this.dispatch('data/kvList', 'Parts')
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addParts(team).then((response) => {
        state.partsList.push(response.data)
        this.dispatch('data/kvList', 'Parts')
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, parts) {
    return new Promise((resolve) => {
      deleteParts(parts.id).then(() => {
        for (const i in state.partsList) {
          if (state.partsList[i].id === parts.id) {
            state.partsList.splice(i, 1)
          }
        }
        this.dispatch('data/kvList', 'Parts')
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
